<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Empresas"}}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras los datos de los empresas registrados." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0">
          <div style="width: 286px;">
            <v-text-field
              v-model="busqueda"
              placeholder="Buscar empresa"
              clearable
              hide-details
              outlined
              style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
              prepend-inner-icon="mdi-magnify"
            />
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" :disabled="!canLinkAccount" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="openAssignDialog()">
            {{ "Asignar empresa" }}
          </v-btn>
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="filteredItems">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ "Id" }}</th>                                                                                                                                             
              <th class="header__title center">{{ "Empresa" }}</th>                                                                                                                                    
              <th class="header__title center">{{ "Tipo de empresa" }}</th>
              <th class="header__title center">{{ "Spread" }}</th>
              <th class="header__title center">{{ "Ejecutivo de ventas" }}</th>
              <th class="header__title center">{{ "Ultima conversion" }}</th>
              <th class="header__title center">{{ "Fecha de creación" }}</th>
              <th class="header__title right">{{ "Acciones" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sSubAccountId }}</td>
              <td class="table__item">{{ item.nombreEmpresa }}</td>
              <td class="table__item">{{ item.tipoEmpresa }}</td>
              <td class="table__item">{{ parseFloat(item.spread).toFixed(6).replace(/\.?0+$/, '') + "%" }}</td>
              <td class="table__item">{{ item.salesExecutive ? item.salesExecutive : '-' }}</td>
              <td class="table__item">{{ item.lastTransactionDate ? formatDate(item.lastTransactionDate) : '-' }}</td>
              <td class="table__item">{{ item.created_at ? formatDate(item.created_at) : '-' }}</td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar comprobante</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="filteredItems">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd; ">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Id" }}</div>
                <div>{{ item.sSubAccountId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Usuario" }}</div>
                <div>{{ item.nombreEmpresa }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de usuario" }}</div>
                <div>{{ item.tipoEmpresa }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Spread" }}</div>
                <div>{{ parseFloat(item.spread).toFixed(6).replace(/\.?0+$/, '') + "%" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Ejecutivo de ventas" }}</div>
                <div>{{ item.salesExecutive || 'N/A' }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Ultima conversion" }}</div>
                <div>{{ item.lastTransactionDate ? formatDate(item.lastTransactionDate) : 'N/A' }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de creación" }}</div>
                <div>{{ item.created_at ? formatDate(item.created_at) : 'N/A' }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Acciones" }}</div>
                <div>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Detalle</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
    <!-- Dialog Asignar Empresa -->
    <v-dialog v-model="dialogAssignEnterprise" v-if="dialogAssignEnterprise" max-width="600px" persistent>
      <v-card>
        <v-container class="mt-1" style="max-width: 600px">
          <v-card-title
            class="pa-0"
            style="display: flex; text-align: center; justify-content: center;"
          >
            <span class="title font-weight-bold text-textblack">
              {{ "Asignar empresa" }}
            </span>
          </v-card-title>

          <v-stepper v-model="currentStep" flat>
            <v-stepper-header>
              <v-stepper-step color="black" :complete="currentStep > 1" step="1">
                Seleccionar empresa
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step color="black" step="2">
                Asignar subcuenta
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- Paso 1: Seleccionar empresa -->
              <v-stepper-content step="1">
                <v-card-text class="py-6 px-4">
                  <v-autocomplete
                    label="Selecciona empresa sin asignar *"
                    :items="unassignedEnterprises"
                    :loading="isLoadingEnterprises"
                    hide-details="auto"
                    style="font-family: 'montserrat-medium'; border-radius: 20px;"
                    outlined
                    clearable
                    item-text="sName"
                    item-value="sCustomerEnterpriseId"
                    v-model="selectedEnterprise"
                    no-data-text="No hay empresas sin asignar"
                  ></v-autocomplete>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="closeAssignDialog()"
                  >
                    {{ "Cancelar" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="!selectedEnterprise"
                    @click="goToStep2()"
                  >
                    {{ "Siguiente" }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>

              <!-- Paso 2: Asignar subcuenta -->
              <v-stepper-content step="2">
                <v-card-text class="py-6 px-4">
                  <v-form ref="assignForm" autocomplete="off">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          label="Empresa seleccionada"
                          :value="selectedEnterpriseName"
                          disabled
                          hide-details
                          style="font-family: 'montserrat-medium'; border-radius: 20px;"
                          outlined
                          class="mb-4"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-autocomplete
                          label="Subcuenta disponible *"
                          :items="availableSubAccounts"
                          :loading="isLoadingSubAccounts"
                          hide-details="auto"
                          style="font-family: 'montserrat-medium'; border-radius: 20px;"
                          outlined
                          clearable
                          class="mb-4"
                          item-text="label"
                          item-value="id"
                          v-model="selectedSubAccount"
                          @change="onSubAccountChange()"
                          no-data-text="No hay subcuentas disponibles"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-autocomplete
                          label="Tipo de cuenta *"
                          :items="typeAccounts"
                          hide-details
                          style="font-family: 'montserrat-medium'; border-radius: 20px;"
                          outlined
                          clearable
                          class="mb-4"
                          item-text="label"
                          item-value="id"
                          v-model="selectedTypeAccount"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          label="Correo de two factor *"
                          hide-details
                          style="font-family: 'montserrat-medium'; border-radius: 20px;"
                          outlined
                          clearable
                          v-model="emailTwoFactor"
                          class="mb-4"
                          type="email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          label="Spread (%) *"
                          v-model="spread"
                          hide-details
                          style="font-family: 'montserrat-medium'; border-radius: 20px;"
                          outlined
                          clearable
                          class="mb-4"
                          type="number"
                          step="0.000001"
                          min="0"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="isLoadingAssign"
                    @click="currentStep = 1"
                  >
                    {{ "Atrás" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="isLoadingAssign || !isStep2Valid"
                    :loading="isLoadingAssign"
                    @click="assignSubAccount()"
                  >
                    {{ "Asignar" }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  import { saveAs } from "file-saver";
  import * as XLSX from "xlsx";
  import { mapGetters } from "vuex";

  export default {
    name: "DashboardView",
    data() {
      return {
        items: [],
        subAccounts: [],
        busqueda: "",
        subaccountDetails: null,
        dialogCreateEnterprise: false,
        selectedSubAccount: null,
        typeAccounts: [
          { id: 'Importador Americano', label: 'Importador Americano' },
          { id: 'Exportador Mexicano', label: 'Exportador Mexicano' },
          { id: 'Importador Mexicano', label: 'Importador Mexicano' },
        ],
        newEnterpriseName: "",
        spread: "",
        selectedTypeAccount: null,
        isLoading: false,
        isLoadingEnterprise: false,
        loading: false,
        balanceMxn: 0,
        balanceUsd: 0,
        tcVenta: 0,
        tcCompra: 0,
        nameXLSX: "",
        emailTwoFactor: "",
        dialogAssignEnterprise: false,
        currentStep: 1,
        unassignedEnterprises: [],
        availableSubAccounts: [],
        selectedEnterprise: null,
        isLoadingEnterprises: false,
        isLoadingSubAccounts: false,
        isLoadingAssign: false,
      };
    },
    methods: {
      getDashboard() {
        this.loading = true;
        this.items = [];
        DB.get(`${URI}/api/v1/en/administrator/enterprises`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          this.loading = false;
          this.items = response.data.users.map((item) => {
            return {
              sEnterpriseId: item.enterprise?.sEnterpriseId,
              sSubAccountId: item.enterprise?.sSubAccountId,
              nombreEmpresa: item.enterprise?.sName || "",
              salesExecutive: item.enterprise?.salesExecutiveName ? (item.enterprise?.salesExecutiveName + " " + item.enterprise?.salesExecutiveLastname) : "",
              tipoEmpresa: item.enterprise?.EnterpriseType,
              spread: item.enterprise?.spread || 0,
              originalItem: item,
              lastTransactionDate: item.enterprise?.lastTransactionDate || null,
              created_at: item.enterprise?.created_at || null
            };
          });
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM D, YYYY");
        return formattedDate;
      },
      openDetail(item) {
        this.$router.push({
          name: "ClientDetail",
          params: { sEnterpriseId: item.sEnterpriseId }
        }).catch(() => {});
      },
      dataXLSX() {
        try {
          let data = this.items.map((item) => {
            return {
              Id: item ? item.sSubAccountId : "",
              Usuario: item ? item.nombreEmpresa: "",
              TipoEmpresa: item ? item.tipoEmpresa: "",
              spread: item ? item.spread : "",
              "Ejecutivo de cuenta": item ? item.salesExecutive : "",
              "Last conversion": item ? item.lastTransactionDate : "",
              "Fecha de creacion": item ? (item.created_at ? this.formatDate(item.created_at) : '') : "",
            };
          });
          const worksheet = XLSX.utils.json_to_sheet(data);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

          const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const date = moment().format("YYYY-MM-DD HH:mm");
          this.nameXLSX = `Wallets_${date}.xlsx`;
          saveAs(blob, this.nameXLSX);
          this.success = true;
          this.msgSuccess = "Descargando documento";
        } catch (error) {
          this.error = true;
          this.codeError = "CSV_NO_DATA";
        }
      },
      getSubAccounts() {
        this.isLoading = true;
        this.subAccounts = [];

        DB.get(`${URI}/api/v1/en/administrator/subaccounts`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          const allSubAccounts = response.data.subAccounts;
          const assignedSubAccountIds = this.items.map(user => Number(user.sSubAccountId));

          this.subAccounts = allSubAccounts
            .filter(sa => !assignedSubAccountIds.includes(sa.id))
            .map(sa => ({
              ...sa,
              label: `${sa.name} - ${sa.id}`
            }));
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      getSubAccountDetails() {
        this.isLoading = true;
        this.subaccountDetails = null;
        const payload = {
          sSubAccountId: this.selectedSubAccount,
        };

        DB.post(`${URI}/api/v1/en/administrator/subaccountDetail`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.subaccountDetails = response.data.subAccount;
          this.balanceMxn = this.subaccountDetails.balance?.balanceMxn?.balance || 0;
          this.balanceUsd = this.subaccountDetails.balance?.balanceUsd?.balance || 0;
          this.tcVenta = this.subaccountDetails.exchangeRate?.mxnRate || 0;
          this.tcCompra = this.subaccountDetails.exchangeRate?.usdRate || 0;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      createEnterprise() {
        this.isLoadingEnterprise = true;
        const payload = {
          newEnterpriseName: this.newEnterpriseName,
          spread: this.spread,
          selectedSubAccount: this.selectedSubAccount,
          selectedTypeAccount: this.selectedTypeAccount,
          emailTwoFactor: this.emailTwoFactor
        };

        DB.post(`${URI}/api/v1/en/administrator/createEnterprise`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.isLoadingEnterprise = false;
          this.getDashboard();
          this.dialogCreateEnterprise = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      openAssignDialog() {
        this.dialogAssignEnterprise = true;
        this.currentStep = 1;
        this.getUnassignedEnterprises();
      },
      closeAssignDialog() {
        this.dialogAssignEnterprise = false;
        this.currentStep = 1;
        this.selectedEnterprise = null;
        this.selectedSubAccount = null;
        this.selectedTypeAccount = null;
        this.emailTwoFactor = "";
        this.spread = "";
        this.balanceMxn = 0;
        this.balanceUsd = 0;
        this.tcVenta = 0;
        this.tcCompra = 0;
        this.unassignedEnterprises = [];
        this.availableSubAccounts = [];
      },
      getUnassignedEnterprises() {
        this.isLoadingEnterprises = true;
        this.unassignedEnterprises = [];

        DB.get(`${URI}/api/v1/en/administrator/unassignedEnterprises`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.unassignedEnterprises = response.data.enterprises;
          this.isLoadingEnterprises = false;
        })
        .catch((error) => {
          this.isLoadingEnterprises = false;
          if (error.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response?.data?.message || "Error al obtener empresas", error.response?.status);
        });
      },
      getAvailableSubAccounts() {
        this.isLoadingSubAccounts = true;
        this.availableSubAccounts = [];

        DB.get(`${URI}/api/v1/en/administrator/availableSubAccounts`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.availableSubAccounts = response.data.subAccounts.map(sa => ({
            ...sa,
            label: `${sa.name} - ${sa.id}`
          }));
          this.isLoadingSubAccounts = false;
        })
        .catch((error) => {
          this.isLoadingSubAccounts = false;
          if (error.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response?.data?.message || "Error al obtener subcuentas", error.response?.status);
        });
      },
      goToStep2() {
        this.currentStep = 2;
        this.getAvailableSubAccounts();
      },
      onSubAccountChange() {
        if (this.selectedSubAccount) {
          this.getSubAccountDetails();
        } else {
          this.balanceMxn = 0;
          this.balanceUsd = 0;
          this.tcVenta = 0;
          this.tcCompra = 0;
        }
      },
      assignSubAccount() {
        this.isLoadingAssign = true;

        const payload = {
          sEnterpriseId: this.selectedEnterprise,
          sSubAccountId: this.selectedSubAccount,
          selectedTypeAccount: this.selectedTypeAccount,
          sAuthEmail: this.emailTwoFactor,
          spread: parseFloat(this.spread)
        };

        DB.post(`${URI}/api/v1/en/administrator/assignSubAccount`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.isLoadingAssign = false;
          this.mixSuccess("Subcuenta asignada correctamente");
          this.closeAssignDialog();
          this.getDashboard();
        })
        .catch((error) => {
          this.isLoadingAssign = false;
          if (error.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response?.data?.message || "Error al asignar subcuenta", error.response?.status);
        });
      }
    },
    computed: {
      ...mapGetters(['hasPermission']),
      canLinkAccount() {
        return this.hasPermission('cf983058-452b-4590-8f14-a55c3c71e32d');
      },
      filteredItems() {
        if (!this.busqueda) return this.items;

        const texto = this.busqueda.toLowerCase();
        return this.items.filter(item => {
          const nombre = item.nombreEmpresa?.toLowerCase() || "";
          const subaccount = item.sSubAccountId?.toLowerCase() || "";
          const tipoEmpresa = item.tipoEmpresa?.toLowerCase() || "";
          const salesExecutive = item.salesExecutive?.toLowerCase() || "";
          const spread = item.spread?.toLowerCase() || "";

          return (
            nombre.includes(texto) ||
            subaccount.includes(texto) ||
            tipoEmpresa.includes(texto) ||
            salesExecutive.includes(texto) ||
            spread.includes(texto)
          );
        });
      },
      selectedEnterpriseName() {
        if (!this.selectedEnterprise) return "";
        const enterprise = this.unassignedEnterprises.find(
          e => e.sCustomerEnterpriseId === this.selectedEnterprise
        );
        return enterprise ? enterprise.sName : "";
      },
      isStep2Valid() {
        return (
          this.selectedSubAccount &&
          this.selectedTypeAccount &&
          this.emailTwoFactor &&
          this.emailTwoFactor.trim() !== '' &&
          this.spread &&
          !isNaN(parseFloat(this.spread)) &&
          parseFloat(this.spread) >= 0
        );
      }
    },
    beforeMount() {
      this.getDashboard();
    },
    beforeDestroy() {
    },
  };
</script>

<style>
</style>
